const data = {
  tariffeOptions: [
    { code: "2.1a", description: "Sì" },
    { code: "2.2a", description: "No" },
  ],
  compagniaOptions: [
    { code: "3.1", description: "Afi Esca" },
    { code: "3.2", description: "Alleanza Assicurazioni" },
    { code: "3.3", description: "Allianz" },
    { code: "3.4", description: "Allianz Global Life" },
    { code: "3.5", description: "Athora Italia" },
    { code: "3.6", description: "Arca Vita" },
    { code: "3.7", description: "Assimoco Vita" },
    { code: "3.9", description: "Aviva Vita" },
    { code: "3.10", description: "AXA Assicurazioni" },
    { code: "3.11", description: "AXA-MPS Assicurazioni Vita" },
    { code: "3.12", description: "BAP Vita e Previdenza" },
    { code: "3.13", description: "BCC Vita" },
    { code: "3.14", description: "Banco BPM Vita" },
    { code: "3.15", description: "Cardif Vita" },
    { code: "3.16", description: "Cattolica Assicurazioni" },
    { code: "3.17", description: "CF Life" },
    { code: "3.18", description: "CNP Assurances" },
    { code: "3.19", description: "UniCredit Life Insurance" },
    { code: "3.8", description: "CNP Vita Assicura" },
    { code: "3.47", description: "CNP Vita Assicurazione" },
    { code: "3.20", description: "Credemvita" },
    { code: "3.21", description: "Crédit Agricole Vita" },
    { code: "3.50", description: "Cronos Vita" },
    { code: "3.23", description: "Darta Saving Life Assurance" },
    { code: "3.24", description: "Eurovita" },
    { code: "3.25", description: "Fideuram Vita" },
    { code: "3.49", description: "GamaLife" },
    { code: "3.26", description: "Generali Italia" },
    { code: "3.51", description: "Genertel" },
    { code: "3.27", description: "Genertellife" },
    { code: "3.28", description: "Grazer Wechselseitige" },
    { code: "3.29", description: "Groupama Assicurazioni" },
    { code: "3.30", description: "HDI Assicurazioni" },
    { code: "3.31", description: "Helvetia Vita" },
    { code: "3.52", description: "Intesa Sanpaolo Assicurazioni" },
    { code: "3.32", description: "Intesa Sanpaolo Vita" },
    { code: "3.33", description: "Italiana Assicurazioni" },
    { code: "3.34", description: "ITAS Vita" },
    { code: "3.35", description: "Lombarda Vita" },
    { code: "3.36", description: "Mediolanum Vita" },
    { code: "3.37", description: "MetLife" },
    { code: "3.38", description: "Net Insurance Life" },
    { code: "3.48", description: "Nobis Vita" },
    { code: "3.39", description: "Poste Vita" },
    { code: "3.40", description: "Pramerica Life" },
    { code: "3.41", description: "Reale Mutua" },
    { code: "3.42", description: "Sara Vita" },
    { code: "3.22", description: "UniCredit Vita Assicurazioni" },
    { code: "3.43", description: "Unipol Assicurazioni" },
    { code: "3.44", description: "PiùVera Protezione" },
    { code: "3.45", description: "Vittoria Assicurazioni" },
    { code: "3.46", description: "Zurich Investments Life" },
  ],
  mercatoOptions: [
    { code: "4.1", description: "Retail" },
    { code: "4.2", description: "Business" },
  ],
  canaleOptions: [
    { code: "5.1", description: "Banca" },
    { code: "5.2", description: "Consulenti Finanziari" },
    { code: "5.3", description: "Agenti" },
    { code: "5.4", description: "Broker" },
    { code: "5.5", description: "Diretto" },
  ],
  prodCommercioOptions: [
    { code: "7.1", description: "Sì" },
    { code: "7.2", description: "No" },
  ],
  tipoAssicurazioneOptions: [
    { code: "11.1", description: "Individuale" },
    { code: "11.2", description: "Collettiva" },
  ],
  tipoProdottoOptions: [
    { code: "13.1", description: "TCM" },
    { code: "13.2", description: "Long Term Care" },
    { code: "13.3", description: "Dread Disease" },
    { code: "13.4", description: "Multigaranzia" },
  ],
  garanzieOptions: [
    { code: "14.1", description: "Decesso (qualsiasi causa)" },
    { code: "14.2", description: "Decesso per infortunio" },
    { code: "14.3", description: "Decesso per incidente stradale" },
    { code: "14.4", description: "Decesso per malattia" },
    { code: "14.5", description: "Decesso nucleo familiare" },
    { code: "14.6", description: "Non autosufficienza" },
    { code: "14.7", description: "Malattie gravi" },
    { code: "14.8", description: "Invalidità/Inabilità" },
    { code: "14.9", description: "Terminal illness" },
  ],
  tipoPrestazioneOptions: [
    { code: "15.1", description: "Capitale" },
    { code: "15.2", description: "Rendita" },
  ],
  tipoCapitaleOptions: [
    { code: "16.1", description: "Costante" },
    { code: "16.2", description: "Decrescente" },
  ],
  tipoRenditaOptions: [
    { code: "18.1", description: "Annua" },
    { code: "18.2", description: "Mensile" },
  ],
  garanzieComplOptions: [
    { code: "21.1", description: "Decesso (qualsiasi causa)" },
    { code: "21.2", description: "Decesso per infortunio" },
    { code: "21.3", description: "Decesso per incidente stradale" },
    { code: "21.4", description: "Decesso per malattia" },
    { code: "21.5", description: "Decesso nucleo familiare" },
    { code: "21.6", description: "Non autosufficienza" },
    { code: "21.7", description: "Malattie gravi" },
    { code: "21.8", description: "Invalidità/Inabilità" },
    { code: "21.9", description: "Terminal illness" },
    { code: "21.10", description: "Altre garanzie assicurative" },
    { code: "21.11", description: "Non presenti" },
  ],
  tipoPremioOptions: [
    { code: "22.1", description: "Annuo" },
    { code: "22.2", description: "Mensile" },
    { code: "22.3", description: "Unico" },
  ],
  frazPremioOptions: [
    { code: "24.1", description: "Mensile" },
    { code: "24.2", description: "Bimestrale" },
    { code: "24.3", description: "Trimestrale" },
    { code: "24.4", description: "Quadrimestrale" },
    { code: "24.5", description: "Semestrale" },
    { code: "24.6", description: "Non previsto" },
  ],
  durataPianoPagamentiOptions: [
    { code: "27.1", description: "Pari alla durata contrattuale" },
    { code: "27.2", description: "Inferiore alla durata contrattuale" },
  ],
  applSpeseEmissioneOptions: [
    { code: "58.1", description: "Sì" },
    { code: "58.2", description: "No" },
  ],
  applCaricamentoPremioOptions: [
    { code: "60.1", description: "Sì" },
    { code: "60.2", description: "No" },
  ],
  applCaricamentoCapitaleOptions: [
    { code: "62.1", description: "Sì" },
    { code: "62.2", description: "No" },
  ],
  applCaricamentoEuroOptions: [
    { code: "64.1", description: "Sì" },
    { code: "64.2", description: "No" },
  ],
  costoVisitaMedicaOptions: [
    { code: "68.1", description: "A carico dell'assicurato" },
    { code: "68.2", description: "A carico della Compagnia" },
    { code: "68.3", description: "Contributo parziale della Compagnia" },
    { code: "68.4", description: "n.d." },
  ],
  presenzaCashbackOptions: [
    { code: "70.1", description: "Sì" },
    { code: "70.2", description: "No" },
  ],
  tipoRetrDistrOptions: [
    { code: "72.1", description: "Percentuale del flusso commissionale" },
    { code: "72.2", description: "Percentuale del premio" },
    { code: "72.3", description: "Non indicata" },
    { code: "72.4", description: "Non prevista" },
  ],
  yesNoOptions: [
    { code: "true", description: "Sì" },
    { code: "false", description: "No" },
  ],
  garanziePrincComplOptions: [
    { code: ".1", description: "Decesso (qualsiasi causa)" },
    { code: ".2", description: "Decesso per infortunio" },
    { code: ".3", description: "Decesso per incidente stradale" },
    { code: ".4", description: "Decesso per malattia" },
    { code: ".5", description: "Decesso nucleo familiare" },
    { code: ".6", description: "Non autosufficienza" },
    { code: ".7", description: "Malattie gravi" },
    { code: ".8", description: "Invalidità/Inabilità" },
    { code: ".9", description: "Terminal illness" },
  ],
};

const selectChoices = {
  tariffe: { code: "", description: "" },
  compagnia: { code: "", description: "" },
  mercato: [], // multiselect
  canale: [], // multiselect
  prodCommercio: { code: "", description: "" },
  tipoAssicurazione: { code: "", description: "" },
  tipoProdotto: { code: "", description: "" },
  garanzie: [], // multiselect
  tipoPrestazione: [], // multiselect
  tipoCapitale: { code: "", description: "" },
  tipoRendita: { code: "", description: "" },
  garanzieCompl: [], // multiselect
  tipoPremio: { code: "", description: "" },
  frazPremio: [], // multiselect
  durataPianoPagamenti: { code: "", description: "" },
  applSpeseEmissione: { code: "", description: "" },
  applCaricamentoPremio: { code: "", description: "" },
  applCaricamentoCapitale: { code: "", description: "" },
  applCaricamentoEuro: { code: "", description: "" },
  costoVisitaMedica: { code: "", description: "" },
  presenzaCashback: { code: "", description: "" },
  tipoRetrDistr: { code: "", description: "" },
};

export { selectChoices };
export default data;
    